(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["upsell-product-card"] && !Shopify.designMode) return;
  try {
    document.addEventListener('submit', async (e) => {
    const form = e.target.closest('.upsell-item__form');
    if (!form) return;
    e.preventDefault();

    const btn = form.querySelector('.upsell-item__btn');
    const variantId = form.querySelector('[name="id"]').value;
    const original = btn.textContent;

    btn.disabled = true;
    btn.textContent = '…';

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] }),
      });
      if (!res.ok) throw new Error();

      // Fetch updated cart to pass to Horizon's cart:update event
      const cart = await fetch('/cart.js').then(r => r.json());

      // Horizon cart drawer listens for 'cart:update' with this detail shape
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart,
          sourceId: null,
          data: { source: 'upsell-product-card', variantId },
        },
      }));

      btn.textContent = '✓';
      setTimeout(() => { btn.textContent = original; btn.disabled = false; }, 2000);
    } catch {
      btn.textContent = original;
      btn.disabled = false;
    }
  });
  } catch(e) { console.error(e); }
})();

})();
